module.exports = __webpack_public_path__ + "static/media/img_4.dff2dd5e.png";